import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=3db5c156&scoped=true&"
import script from "./EditProfile.vue?vue&type=script&lang=ts&"
export * from "./EditProfile.vue?vue&type=script&lang=ts&"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=3db5c156&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3db5c156",
  null
  
)

export default component.exports